export const locale = {
    "Loading...": "Юкланмоқда...",
    actions: "Амаллар",
    requestAcceptedDate: "Қабул қилинган сана",
    exportToWord: "Wordга юклаш",
    exportToExcel: "Excelга юклаш",
    name: {
        lt: "Nomi (lotin)",
        ru: "Название (русский)",
        uz: "Номи (кирилл)",
        en: "Name (english)",
    },
    lang: {
        russian: "Русский",
        uzbekLatin: "O‘zbek (Lotin)",
        uzbekKrill: "Ўзбек (кирилл)",
        english: "English",
    },
    calendarPriority: {
        VERY_IMPORTANT: "Жуда муҳим",
        IMPORTANT: "Муҳим",
        NORMAL: "Оддий",
    },
    calendarUi: {
        today: "Бугун",
        more: "яна",
        allDay: "Кун бўйи",
    },
    monday: "Душанба",
    mon: "ДУШ",
    tuesday: "Сешанба",
    tue: "СЕШ",
    wednesday: "Чоршанба",
    wed: "ЧОР",
    thursday: "Пайшанба",
    thu: "ПАЙ",
    friday: "Жума",
    fri: "ЖУМ",
    saturday: "Шанба",
    sat: "ШАН",
    sunday: "Якшанба",
    sun: "ЯКШ",
    regions: "Вилоят",
    aboutProvidedLegalAid:
        "Давлат ҳисобидан юридик ёрдам кўрсатилганлиги тўғрисида",
    referenceCertificate: "Маълумотнома",
    corruption: "Коррупция",
    lawyerH: "Aдвокатлар ҳайъати",
    oneIIdAuth: "OneID autentifikatsiyasi",
    dutyScheduleHeader:
        "{region}да {year} йил {month} ойида жиноят ишлари бўйича давлат ҳисобидан юридик ёрдам кўрсатувчи адвокатларнинг НАВБАТЧИЛИК ЖАДВАЛИ",
    oneIIdAuthDesc:
        "OneID autentifikatsiyasi orqali tizimga kirish jarayoni boshlandi. Iltimos, Sahifa yuklanishi tugallanishini kuting...",
    bankName: "Банк номи",
    diplom: {
        title: "Диплом маълумотлари",
    },
    forPersonsWithDisabilities: "Ногиронлиги бўлган шахслар учун",
    mediatorsRegistry: "Медиаторлар реестри",
    legalAdviceOrganizationsRegistry: "Юридик маслаҳат ташкилотлари реестри",
    violenceLegalAidSkills:
        "Зўравонликдан жабрланган аёллар ва болаларга ихтисослашган ҳуқуқий ёрдам кўрсатишга оид кўникмаларни ривожлантириш",
    petitionToCourtInfo:
        "Судга ариза (даъво ариза) ва шикоят киритилганлиги ҳақида маълумот",
    successAtWorkInfo: "Ишда муваффақият қозонганлиги ҳақидаги маълумотлар",
    work: {
        title: "Мехнат фаолияти",
        start_date: "Иш бошланган санаси",
        end_date: "Иш тугатган санаси",
        company_name: "Ташкилот",
        company_inn: "СТИР",
        position_name: "Лавозим",
        structure_name: "Бўлим",
    },
    lexUz: "Ўзбекистон Қонун ҳужжатлари маълумотлари миллий базаси",
    adliya: "Ўзбекистон Республикаси Адлия вазирлиги расмий сайти",
    yurxizmat: "Ўз-ўзига ҳуқуқий хизмат кўрсатиш “Legal Tech”",
    conviction: {
        title: "Судланганлик ёки судланмаганлик ҳолати",
    },
    new: "Янги",
    serviceType: "Хизмат тури",
    selectOrganization: "Ташкилотни танланг",
    birdarchaInvoiceStatus: "Тўлов ҳолати",
    birdarchaStatus: {
        PAID: "Тўланган",
        OPEN: "Тўланмаган",
    },
    jiemMeetings: "ЖИЭМда учрашувлар",
    jiedVisits: {
        permission: "Рухсатнома",
        visitTime: "Учрашув вақти",
        suspect: "Гумонланувчи",
        room: "Хона",
        colony: "Муассаса",
        checkAvailability: "Бўш вақтларни аниқлаш",
        selectedTime: "Танланган вақт",
        selectedRoom: "Танланган хона",
        availableTime: "Бўш вақт оралиғи",
        startTime: "Бошланиш вақти",
        endTime: "Тугаш вақти",
        timeRangeWarning:
            "Танланган вақт бўш вақт оралиғи ичида бўлиши керак",
        emergencyStartTimeWarning:
            "Бошланиш вақти 18:00 дан 08:00 гача бўлиши керак",
        createVisit: "Рухсатнома олиш",
        createVisitSuccess: "Рухсатнома муваффақиятли яратилди",
        cancelVisit: "Бекор қилиш",
        cancelReason: "Бекор қилиш сабаби",
        cancelVisitSuccess: "Учрашув бекор қилинди",
        missingClientPnfl: "Ҳимоя қилинаётган шахс ЖШШИР топилмади",
        presenceCheckError: "Муассасадаги мавжудликни текширишда хатолик",
        visitTypes: {
            current: "Онлайн навбат",
            liveQueue: "Жонли навбат",
            emergency: "Кечиктириб бўлмас",
        },
        statuses: {
            APPROVED: "Тасдиқланган",
            CANCELLED_BY_LAWYER: "Адвокат томонидан бекор қилинган",
            CANCELLED_BY_JIED: "ЖИЭМ тизими орқали бекор қилинган",
            PENDING: "Жараёнда",
            REJECTED: "Рад этилган",
            CANCELLED: "Бекор қилинган",
            CANCELED: "Бекор қилинган",
        },
    },
    eGovernmentDataType: {
        YATT: "ЯТТ тўғрисида маълумот",
        DIPLOM: "Олий таълим тўғрисидаги диплом маълумоти",
        VTEK: "Тиббий-меҳнат эксперт комиссияси ҳисобида туришлиги",
        CADASTRE: "Кўчмас мулк ҳақида маълумотнома",
        CADASTRE_LIST: "Кўчмас мулк кадастр рақамлари рўйхати",
        NARCO_DISPANSER: "Наркодиспансерда ҳисобда туриши тўғрисида маълумот",
        PSYCHO_DISPANSER: "Психдиспансерда ҳисобда туриши тўғрисида маълумот",
        CRIMINAL_RECORDS: "Судланганлиги тўғрисида маълумот",
        SOCIAL_PROTECTION: "Камбағал оилалар реестрида маълумотномаси",
        BIRTH: "Туғилганлик гувоҳномаси маълумотларини олиш",
        MARRIAGE: "Никоҳ гувоҳномаси маълумотларини олиш",
        DEATH: "Вафот этганлик гувоҳномаси маълумотларини олиш",
        DIVORCE: "Ажрашиш гувоҳномаси маълумотларини олиш",
        POSITION: "Жорий иш жойи тўғрисида маълумот",
        POSITION_HISTORY: "Иш жойлари тарихи тўғрисида маълумот",
        BIRDARCHA: "Бирдарчадан Уставларни юклаб олиш",
        BIRDARCHA_USTAV: "Бирдарчадан Уставларни юклаб олиш",
    },
    clickToShow: "Кўриш учун босинг",
    orderNumber: "Буйруқ раками",
    checklist: {
        pdfHeaderText:
            "ЎЗБЕКИСТОН РЕСПУБЛИКАСИ АДЛИЯ <br> ВАЗИРЛИГИ <br> “ЮРИДИК ЁРДАМ” АХБОРОТ ТИЗИМИ",
    },
    announcement: {
        menu: "Вакансия эълон қилиш",
        title: "Вакантлар",
        description: "Стажёр ва адвокат ёрдамчиси учун",
        address: "Манзили",
        phone: "Телефон рақами",
        contragent: "Ташкилот номи",
        sendDate: "Ҳужжат юборилган вақти",
        createDate: "Яратилган сана",
        endDate: "Вакант муддати",
        status: "Ҳолати",
        classificatory: "Классификатор",
        count: "Вакант сони",
        longitude: "Жойлашган жойи (Узунлик)",
        latitude: "Жойлашган жойи (Кенглик)",
        vacancy: "Вакансия",
        vacancyType: "Вакансия тури",
        isPayedTrue: "Тўланадиган",
        isPayedFalse: "Тўланмайдиган",
        amount: "Сумма",
        payTitle: "Ищ хақи",
    },
    sidebar: {
        calendar: "Календарь",
        myWorks: "Менинг ишларим",
        requests: "Аризалар",
        contracts: "Шартномалар",
        incoming: "Кирувчи",
        outgoing: "Чиқувчи",
        lawyerApplication: "Адвокатга ариза юбориш",
        lawyerApplicationForm: "Ариза  юбориш",
        lawyerApplicationIntern: "Стажёр ва адвокат ёрдамчилари аризалари",
        lawyerApplicationInternRestr: "Стажёр реестирига қўшиш",
        lawyerApplicationList: "Менинг аризаларим",
        draft: "Қоралама",
        docTemplate: "Шаблонлар",
        orders: "Ордерлар",
        reports: "Ҳисоботлар",
        statisticInfo: "Статистика",
        profile: "Профил",
        letterDocuments: "Хатлар ва ҳужжатлар",
        control: "Бошқарув",
        queryLog: "Сўровлар журнали",
        userGuide: "Фойдаланувчи қўлланмалари",
        documentsChamberOfAdvocates: "Адвокатлар палатаси ҳужжатлари",
        legalServiceInfo: "Advokatlik xizmatidan foydalanish",
    },
    reports: {
        halfYearly: "Адвокатларнинг ярим йиллик ҳисоботи",
        semiAnnual: "Ярим йиллик ҳисоботи",
        FIRST_HALF_YEAR: "Биринчи ярим йиллик",
        SECOND_HALF_YEAR: "Иккинчи ярим йиллик",
        notification: "Тест синовлари учун ишга туширилди.",
        type: "Ҳисобот тури",
    },
    mentor: "Ментор",
    expertise: {
        paymentStatus: "Тўлов ҳолати",
        actionType: "Ҳаракат тури",
        type: "Тип экспертизы",
        organization: "Организация",
        researchType: "Тип исследования",
        comment: "Комментарий",
        paymentDetail: "Тўлов тафсилотлари",
        response: "Тайинланган експертизалар сони",
        conclusionNumber: "Хулоса рақами",
        deadline: "Крайний срок",
        paymentAt: "Тўланган сана",
        docType: "Тури",
        status: {
            DIRECTED: "Хужжат кўриб чиқиш учун юборилди",
        },
    },
    pleaseInstallEimzo:
        "Илтимос, E-Imzo дастурини ўрнатинг ва ишга туширинг!!!",
    newVersion: {
        badge: "Янги версия",
        lawyerCabinet: "Адвокатлар кабинети",
        citizenCabinet: "Фуқаролар кабинети",
    },
};
